import React, { useState } from 'react'
import { Link } from "gatsby"
import styled from "styled-components"
import { FaCaretRight, FaStickyNote } from 'react-icons/fa';

var Container = styled.div`
    /* font-family:'Roboto'; */
    color:#000000;
`
var LinkD = styled.div`
    padding-left: 15px;
`

var LinkDesc = styled.div`
    padding-left: 15px;
    font-size: 14px;
`

var LinkDiv = styled(Link)`
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    width: 30%;
    color:#1d1d1d;
    text-decoration:none;
    flex-direction:row;
    margin:10px;
    & :hover{
      color: ${({ theme }) => theme.colors['secondary']};
    }
    @media screen and (max-width: 700px) {
    width:43%   
    }
    @media screen and (max-width: 375px) {
    width:100%   
    }
`

var LinkAnchor = styled.a`
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    width: 30%;
    color:#1d1d1d;
    text-decoration:none;
    flex-direction:row;
    margin:10px;
    & :hover{
      color: ${({ theme }) => theme.colors['secondary']};
    }
    @media screen and (max-width: 700px) {
    width:43%   
    }
    @media screen and (max-width: 375px) {
    width:100%   
    }
`
var LinkWrapper = styled.div`
    display:flex;
    flex-wrap:wrap;
`
var TextStack = styled.div`
display: flex;
flex-direction: column;
`;
var SpanMore = styled(LinkWrapper)`
display:${props => props.block ? "flex" : "none"};
`
var Span = styled.span`
width:100%;
display:${props => props.block ? "none" : "block"};
margin: 10px;
color: red;
cursor: pointer;
&:hover{
    color:#950000;
}
`
export default function LinkBlock(props) {
    var arr = props.multipleLink || [
        { title: "This is Test", href: "https://www.airasia.com/" },

    ]
    arr = arr.filter(x => x.href !== null)
    var Alinks = (x, index) => {
        let [title, desc] = x.title.split("|");
        let LinkComponent = x.href.includes("flights/search") ? LinkAnchor : LinkDiv;
        return(
            <LinkComponent to={x.href.replace("https://www.airasia.com/flights", "")} href={x.href}
                key={"Alink" + index} >
                    <TextStack>
                        <LinkD >{title}</LinkD>
                        {desc ? <LinkDesc >{desc}</LinkDesc> : null}
                    </TextStack>
                <FaCaretRight style={{ height: "2em", color: "#cccccc" }} />
            </LinkComponent>
        )
    }
    var [Toggle, SetToggle] = useState(false)
    return (<>
        <Container>
            <LinkWrapper >
                {arr.slice(0, 18).map(Alinks)}

            </LinkWrapper>
            {
                arr.length > 18 ? <><Span onClick={() => SetToggle(true)} block={Toggle}>More...</Span>
                    <SpanMore block={Toggle}>{arr.slice(18).map(Alinks)}
                        <Span onClick={() => SetToggle(false)} >Less...</Span>
                    </SpanMore>
                </> : null
            }
        </Container>
    </>
    )
}
